/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceInfoDto { 
    browserName?: string | null;
    browserVersion?: string | null;
    osName?: string | null;
    osVersion?: string | null;
    deviceType?: string | null;
}

